import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import * as actionTypes from '../../../../store/actions/actionTypes';
import pdfSvg from '../../../../assets/images/pdf.svg';
import {clinicalFlagScoreButtonClass} from "../../../../utils/clinicalFlagColors";

const AdmissionList_Item_ManagerCustomUI_PreAdmission = ({admission, customUI}) => {
    const dispatch = useDispatch();
    const showSetModal = () => dispatch({type: actionTypes.MODAL_CUSTOM_UI_PRE_ADMISSION_SET_SHOW, admission, customUI})

    const showPreviewModal = () => dispatch({type: actionTypes.MODAL_CUSTOM_UI_UPLOAD_PREVIEW_PDF_SHOW, admission, customUI})
    const showPreviewApiModal = () => dispatch({type: actionTypes.MODAL_CUSTOM_UI_UPLOAD_PREVIEW_PDF_SHOW, admission, customUI})

    // The row may still belong to the previously selected hospital while the
    // columns are already rendered from the new one - its manager_customUI map
    // has no entry for this customUI id then. Render the neutral state instead
    // of crashing the whole list (IMP-889).
    const uiData = (admission.manager_customUI || {})[customUI.id] || {};

    if(uiData.apiId || uiData.idLink) {
        if (customUI.clinicalFlags_show) {
            const rating = admission.clinicalFlags_summaryRating;
            let fallbackClass = 'btn-success10 text-success';
            if (admission.clinicalFlags_maxPriority === 3) {
                fallbackClass = 'btn-purple text-purple';
            } else if (admission.clinicalFlags_maxPriority === 2) {
                fallbackClass = 'btn-warning10 text-warning';
            } else if (rating !== undefined && rating >= 1) {
                fallbackClass = 'btn-danger10 text-danger';
            }
            const scoreClass = clinicalFlagScoreButtonClass(admission, fallbackClass);
            const showFlagsModal = () => dispatch({type: actionTypes.MODAL_CLINICAL_FLAGS_SHOW, admission, customUI});
            return <>
                <button type="button" className={`btn-group-table-button btn ${scoreClass}`} onClick={showFlagsModal}>{rating === undefined ? 0 : rating}</button>
            </>
        }
        return <>
            <button type="button" className="btn-sm-tick btn btn-success10 text-success"><span className="icon ico-checkmark" onClick={showPreviewApiModal}></span></button>
        </>
    }
    if(uiData.statusUpload) {
        return <>
            <button className="btn-pink btn-sm btn btn-success10 text-success" onClick={showPreviewModal}><img src={pdfSvg} /></button>
        </>
    }

    return <button className="btn-group-table-button btn btn-gray10 pad046" onClick={showSetModal}>-</button>
}

export default AdmissionList_Item_ManagerCustomUI_PreAdmission;